export const IMAGE_BASE_URL = "https://r2-image-worker.homeapp.workers.dev/"

export const PAGE_PARAM_STATES = {
    CITY: "cityParam",
    QUESTION: "questionParam",
    NEIGHBOURHOOD: "neighbourhoodParam",
};